import { useEffect, useRef, useState } from 'react'
import { QRCodeCanvas } from 'qrcode.react'

/*
 * The QR as a PNG rather than inline SVG.
 *
 * Samsung Internet turns its dark mode on by default and inverts the page on
 * its own, ignoring both color-scheme and prefers-color-scheme. An inline SVG
 * is DOM, so its fills get inverted too and the QR came out light grey on dark
 * grey. A raster image is left alone, so the code keeps black modules on white
 * whatever the browser does to the rest of the page.
 *
 * The canvas qrcode.react draws into stays out of the layout: it is only the
 * source for toDataURL.
 */
const QRCodePng = ({ value, size, id }) => {
  const canvasHolder = useRef(null)
  const [src, setSrc] = useState(null)

  useEffect(() => {
    const canvas = canvasHolder.current?.querySelector('canvas')
    if (canvas) {
      setSrc(canvas.toDataURL('image/png'))
    }
  }, [value, size])

  return (
    <>
      <div ref={canvasHolder} style={{ display: 'none' }} aria-hidden={'true'}>
        <QRCodeCanvas value={value} size={size} includeMargin />
      </div>
      {src ? (
        <img src={src} width={size} height={size} id={id} alt={'qr'} />
      ) : (
        <div style={{ width: size, height: size }} />
      )}
    </>
  )
}

export default QRCodePng
